// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const creditLinkageCompletion = "CreditLinkageCompletion__creditLinkageCompletion__q7g4m";
export const subtitleParagraph = "CreditLinkageCompletion__subtitleParagraph__zZsFp";
export const summary = "CreditLinkageCompletion__summary__2Yu3K";
export const buttonContainer = "CreditLinkageCompletion__buttonContainer__T7EXU";